export const BLOCKING_LEAVE_APPLICATION_MESSAGE = "該生已開立退宿/離宿申請單，請至離退宿申請作業處理";

export function hasBlockingLeaveApplication(leaveStatus) {
	return Boolean(leaveStatus) && leaveStatus !== "R";
}